import { GrowthBook } from '@growthbook/growthbook-react';
import { v4 as uuidv4 } from 'uuid';

const GROWTHBOOK_DEVICE_ID_KEY = 'GrowthBookDeviceId';

export const growthbook = new GrowthBook({
  apiHost: process.env.REACT_APP_GROWTHBOOK_API_HOST,
  clientKey: process.env.REACT_APP_GROWTHBOOK_CLIENT_KEY,
  enableDevMode: ['LOCAL', 'TEST', 'STAGING'].includes(process.env.REACT_APP_BRANCH),
});

export const getDeviceId = () => {
  const storedDeviceId = localStorage.getItem(GROWTHBOOK_DEVICE_ID_KEY);
  if (storedDeviceId) return storedDeviceId;

  const deviceId = uuidv4();
  localStorage.setItem(GROWTHBOOK_DEVICE_ID_KEY, deviceId);

  return deviceId;
};
